import commonObj from 'commonObj';
import localStorage from './local-storage';

const cbs = window._cbs ?? {
  pv() {},
  action() {},
  success() {},
  failure() {},
  setDefault() {}
};

const directive = (el, binding) => {
  if (el.getAttribute('data-cbs-value')) {
    // 更新
    el.setAttribute('data-cbs-value', JSON.stringify(binding.value));
    return;
  }

  const method = binding.arg || 'action';
  const eventName = Object.keys(binding.modifiers)[0] || 'click';

  el.setAttribute('data-cbs-value', JSON.stringify(binding.value));

  el.addEventListener(eventName, () => {
    let name;
    let params;

    const value = JSON.parse(el.getAttribute('data-cbs-value'));

    if (typeof value === 'object') {
      name = value.name;
      params = value;
      delete params.name;
    }
    else {
      name = value;
    }

    cbs[method]?.(name, params);
  });
};

// 获取 URL 来源参数
const getUrlSource = () => {
  let source = '';
  const storageName = 'changba-music-mall-url-source';
  // URL 来源参数有效期，单位：秒
  const URL_SOURCE_EXPIRES = 60 * 60 * 2;

  let data = JSON.parse(localStorage.getItem(storageName)) || {};
  const sourceParam = commonObj.utils.getQueryStrFn('buy_source') || commonObj.utils.getQueryStrFn('refsrc') || '';

  const now = new Date().getTime();

  if (sourceParam) {
    source = sourceParam;
    data = {
      value: sourceParam,
      time: now
    };
    localStorage.setItem(storageName, JSON.stringify(data));
  }
  else {
    if (data?.value) {
      const time = Number(data.time);

      if (!isNaN(time)) {
        // 过期时间 2 小时
        if (now - time > URL_SOURCE_EXPIRES * 1000) {
          // 过期了
          data = {};
        }
        else {
          source = data.value;
        }
      }
      else {
        // time 值非法，认为过期了
        data = {};
      }

      localStorage.setItem(storageName, JSON.stringify(data));
    }
  }

  return source;
};

cbs.setDefault('extra', {
  refsrc: getUrlSource()
});

export default {
  install(Vue) {
    Vue.directive('cbs', directive);

    Vue.prototype.$cbs = cbs;
  }
};

export { getUrlSource };
